/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagenolimit3Inputs */

const en_ticketpagenolimit3 = /** @type {(inputs: Ticketpagenolimit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

const de_ticketpagenolimit3 = /** @type {(inputs: Ticketpagenolimit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Obergrenze`)
};

/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Ticketpagenolimit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagenolimit3 = /** @type {((inputs?: Ticketpagenolimit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagenolimit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagenolimit3(inputs)
	return de_ticketpagenolimit3(inputs)
});
export { ticketpagenolimit3 as "ticketPageNoLimit" }